import { clsx } from 'clsx'
import { ChangeEvent, ReactNode } from 'react'
import css from './Radio.module.scss'

type Props<Data> = {
  checked?: boolean
  children?: ReactNode
  className?: string
  data?: Data
  disabled?: boolean
  error?: boolean
  onChange?(checked: boolean, data: Data): void
}

export const Radio = <Data = void,>(props: Props<Data>) => {
  const { checked, children, data, disabled, error, onChange } = props
  const className = clsx(
    props.className,
    css.radio,
    checked && css.checked,
    error && css.error
  )

  const onChangeRadio = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked
    if (onChange) onChange(checked, data!)
  }

  return (
    <label className={className}>
      <div className={css.radio}>
        <input
          type="radio"
          checked={checked}
          disabled={disabled}
          onChange={onChangeRadio}
        />
      </div>
      {children && <span className={css.text}>{children}</span>}
    </label>
  )
}
